import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigOffice365McpSettings } from "./app-settings-config-ofice-365-mcp";

export interface IConfigOffice365McpInputState {
  showModal: boolean;
  editingOffice365McpId: string;
}

export interface IConfigOffice365McpInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigOffice365McpInput extends PureComponent<
  IConfigOffice365McpInputProps,
  IConfigOffice365McpInputState
> {
  formInputName: string[] = ["apiConfig", "office365McpSettingsId"];

  constructor(props: IConfigOffice365McpInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingOffice365McpId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingOffice365McpId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingOffice365McpId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigOffice365McpSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingOffice365McpId={this.state.editingOffice365McpId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Office 365"
          formInputName={this.formInputName}
          options={this.props.commonSettings.office365McpSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_office365mcp"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpOffice365Dropdown"
          addNewTestId="appSettingsMcpOffice365AddNewButton"
          editTestId="appSettingsMcpOffice365EditButton"
        />
      </>
    );
  }
}
